export const IProgressStep = Object.freeze({
  missing: "missing",
  total: "total",
});

export class ProgressStepModel {
  constructor(data = {}) {
    this[IProgressStep.missing] = data[IProgressStep.missing];
    this[IProgressStep.total] = data[IProgressStep.total];
  }

  getMissing() {
    return this[IProgressStep.missing];
  }

  getTotal() {
    return this[IProgressStep.total];
  }
}
